import getSymbolFromCurrency from "currency-symbol-map";

export const getMoney = (iso2) => {
  const symbol = getSymbolFromCurrency(iso2);
  return symbol || iso2;
};

export const formatNumber = (number) => {
  return new Intl.NumberFormat("es-ES", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(number);
};

export const formatLowerCase = (str) => {
  return str.toLowerCase();
};

export const validateImageURL = async (src) => {
  return new Promise((resolve) => {
    if (!src) {
      resolve(false);
      return;
    }

    const img = new Image();
    img.src = src;

    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);

    // En caso de que nunca cargue (por seguridad), un timeout
    setTimeout(() => resolve(false), 3000);
  });
};
